export const ROME = "Europe/Rome";

export function parseApiDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const text = String(value).trim();
  if (!text) return null;
  const normalized = text.includes("T") ? text : text.replace(" ", "T");
  const hasZone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized);
  const date = new Date(hasZone ? normalized : `${normalized}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRomeDateTime(value, options = {}) {
  const date = parseApiDate(value);
  if (!date) return value ? String(value) : "";
  return date.toLocaleString("it-IT", { ...options, timeZone: ROME });
}

export function romeDatetimeToUtc(value) {
  if (/(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) return parseApiDate(value).toISOString();
  const target = String(value).slice(0, 16);
  const wall = Date.parse(`${target}:00Z`);
  if (!Number.isFinite(wall)) throw new Error("Data e ora non valide");
  // Try offsets on both sides of a DST transition. For repeated autumn times,
  // choose the first occurrence, matching the backend's fold=0 convention.
  const candidates = [-86400000, 0, 86400000].map((delta) => {
    const sample = wall + delta;
    const shown = Date.parse(`${toRomeDatetimeLocal(new Date(sample))}:00Z`);
    return wall - (shown - sample);
  }).filter((instant) => toRomeDatetimeLocal(new Date(instant)) === target);
  if (candidates.length) return new Date(Math.min(...candidates)).toISOString();
  throw new Error("L'orario non esiste nel fuso di Roma per il cambio dell'ora");
}

export function toRomeDatetimeLocal(value) {
  const date = parseApiDate(value);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: ROME,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const map = Object.fromEntries(parts.filter((part) => part.type !== "literal").map((part) => [part.type, part.value]));
  const hour = map.hour === "24" ? "00" : map.hour;
  return `${map.year}-${map.month}-${map.day}T${hour}:${map.minute}`;
}

export function isSameRomeDay(value, reference = new Date()) {
  const date = parseApiDate(value);
  if (!date) return false;
  const fmt = (item) => new Intl.DateTimeFormat("en-CA", { timeZone: ROME }).format(item);
  return fmt(date) === fmt(reference);
}
